import { Customer } from "../../types/customer";
import { Drawer } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Fragment } from "react";
import { Grid, Stack, Typography, Card, CardContent } from "@mui/material";
import { IconButton } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { SvgIcon } from "@mui/material";
import { Box } from "@mui/material";
import { Button } from "@mui/material";

import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

type Anchor = "top" | "left" | "bottom" | "right";

const ExpandAllIcon = () => (
    <SvgIcon sx={{ color: "#432568", fontSize: 20 }} viewBox="0 -960 960 960">
        <path d="M480-80 240-320l57-57 183 183 183-183 57 57L480-80ZM298-584l-58-56 240-240 240 240-58 56-182-182-182 182Z" />
    </SvgIcon>
);

const CollapseAllIcon = () => (
    <SvgIcon sx={{ color: "#432568", fontSize: 20 }} viewBox="0 -960 960 960">
        <path d="m296-80-56-56 240-240 240 240-56 56-184-184L296-80Zm184-504L240-824l56-56 184 184 184-184 56 56-240 240Z" />
    </SvgIcon>
);

export default function CustomerOrgStructure(props: {
    dockAt?: "top" | "left" | "bottom" | "right";
    show?: boolean;
    handleClose: () => void;
    cust?: Customer;
    orgStructure?: any;
    refreshTable?: () => void;
    displayClientFiling?: () => void;
    onCustomerClick?: (customer: any) => void;
    selectedClientId?: number;
}) {
    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });
    const [organizationalStructure, setOrganizationalStructure] = React.useState<any>(null);
    const [expanded, setExpanded] = React.useState<Record<number, boolean>>({});

    const toggleNode = (customerId: number) => {
        setExpanded(prev => ({
            ...prev,
            [customerId]: !prev[customerId]
        }));
    };

    const collapseAll = () => {
        setExpanded({});
    };

    const getExpandableNodes = (
        node: any,
        expandedNodes: Record<number, boolean> = {}
    ) => {
        if (
            node.clientType === "Parent" ||
            node.clientType === "Child"
        ) {
            expandedNodes[node.customerId] = true;
        }

        node.children?.forEach((child: any) =>
            getExpandableNodes(child, expandedNodes)
        );

        return expandedNodes;
    };

    const expandAll = () => {
        if (!organizationalStructure) return;

        const expandedNodes = getExpandableNodes(organizationalStructure);

        setExpanded(expandedNodes);
    };

    const toggleDrawer =
        (anchor: Anchor, open: boolean) =>
            (event: React.KeyboardEvent | React.MouseEvent) => {
                // Keep your existing logic here if needed
            };

    const handleCancel = async (anchor: Anchor) => {
        collapseAll(); // Collapse all nodes
        setState({ ...state, [anchor]: false });
        props.handleClose();
    };

    // ==========================================
    // Extracted onClick Handler Function
    // ==========================================
    const handleNodeClick = async (e: React.MouseEvent, node: any, isSelected: boolean) => {
        e.stopPropagation(); // prevent expand/collapse clicking the text
        console.log("handleNodeClick", "isSelected", isSelected, "node", node);

        // Only trigger the click events if it's NOT the selected client
        if (!isSelected) {
            const res = await axios.get(`${API_BASE_URL}/Customer/CustomerList`, {
                params: {
                    customerId: node.customerId,
                },
            });
            const fullCustomerDetails = res.data[0];
            console.log("handleNodeClick", "fullCustomerDetails", fullCustomerDetails,);

            props.onCustomerClick?.(fullCustomerDetails);

            // Pass the dockAt prop as the required anchor argument
            if (props.dockAt) {
                handleCancel(props.dockAt);
            } else {
                // Fallback just in case dockAt is undefined
                collapseAll();
                props.handleClose();
            }
        }
    };

    const renderNode = (node: any, level = 0) => {
        // Check if this node is the currently selected client
        const isSelected = String(props.selectedClientId) === String(node.customerId);

        const isExpanded = expanded[node.customerId];
        const isParent = node.clientType === "Parent";
        const isChild = node.clientType === "Child";
        const isSubChild = node.clientType === "SubChild";
        const hasChildren = node.children && node.children.length > 0;

        // Parent and Child always have expand icon
        const showExpandIcon = isParent || isChild;

        return (
            <Box key={node.customerId}>
                <Stack
                    direction="row"
                    alignItems="center"
                    sx={{
                        pl: level * 4,
                        py: 0.5,
                        cursor: showExpandIcon ? "pointer" : "default",
                    }}
                    onClick={() =>
                        showExpandIcon && toggleNode(node.customerId)
                    }
                >
                    {showExpandIcon ? (
                        isExpanded ? (
                            <KeyboardArrowDownIcon fontSize="small" />
                        ) : (
                            <KeyboardArrowRightIcon fontSize="small" />
                        )
                    ) : (
                        <FiberManualRecordIcon
                            sx={{
                                fontSize: 8,
                                ml: 1,
                            }}
                        />
                    )}

                    <Typography
                        sx={{
                            ml: 1,
                            fontSize: 13,
                            cursor: isSelected ? "default" : "pointer",
                            color: isSelected ? "text.secondary" : "#000000",
                            fontWeight: isSelected ? 600 : 400,
                            "&:hover": {
                                textDecoration: "none",
                                fontWeight: isSelected ? 600 : "bold",
                                color: isSelected ? "text.secondary" : "#432568",
                            },
                        }}
                        // Use the extracted function here
                        onClick={(e) => handleNodeClick(e, node, isSelected)}
                    >
                        {node.customerName}
                    </Typography>
                </Stack>

                {showExpandIcon && isExpanded && (
                    <>
                        {hasChildren ? (
                            node.children.map((child: any) => renderNode(child, level + 1))
                        ) : (
                            <Typography
                                sx={{
                                    pl: (level + 1) * 4 + 4,
                                    py: 0.5,
                                    fontSize: 13,
                                    color: "text.secondary",
                                    fontStyle: "italic",
                                }}
                            >
                                {isParent
                                    ? "Parent does not have any child"
                                    : "Doesn't have sub child under this child"}
                            </Typography>
                        )}
                    </>
                )}
            </Box>
        );
    };

    const list = (anchor: Anchor) => (
        <Fragment>
            <Grid container>
                <Stack
                    sx={{
                        width: anchor === "top" || anchor === "bottom" ? "auto" : "20vw",
                        minWidth: "35vw",
                        display: "flex",
                        alignContent: "center",
                    }}
                    role="presentation"
                    onClick={toggleDrawer(anchor, false)}
                    onKeyDown={toggleDrawer(anchor, false)}
                >
                    <Card className="tn-comments-drawer-card" sx={{ border: "none", boxShadow: "none" }}>
                        <CardContent sx={{ mx: "10px", my: "10px" }}>
                            <Stack direction="column">
                                <Stack
                                    className="tn-comments-header"
                                    direction="row"
                                    justifyContent="space-between"
                                    sx={{ marginBottom: "15px" }}
                                >
                                    <Typography
                                        gutterBottom
                                        variant="h5"
                                        component="div"
                                        sx={{
                                            fontWeight: "medium",
                                            fontSize: "16px",
                                            color: "#424242",
                                        }}
                                    >
                                        ORGANIZATIONAL STRUCTURE
                                    </Typography>

                                    <IconButton>
                                        <CloseIcon onClick={() => handleCancel(anchor)} />
                                    </IconButton>
                                </Stack>

                                <Stack spacing={2}>
                                    <Stack direction="row" spacing={2}>
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            startIcon={<ExpandAllIcon />}
                                            onClick={expandAll}
                                            sx={{
                                                textTransform: "none",
                                                borderRadius: 2
                                            }}
                                        >
                                            Expand All
                                        </Button>

                                        <Button
                                            variant="outlined"
                                            size="small"
                                            startIcon={<CollapseAllIcon />}
                                            onClick={collapseAll}
                                            sx={{
                                                textTransform: "none",
                                                borderRadius: 2
                                            }}
                                        >
                                            Collapse All
                                        </Button>
                                    </Stack>

                                    {organizationalStructure &&
                                        renderNode(organizationalStructure)}
                                </Stack>
                            </Stack>
                        </CardContent>
                    </Card>
                </Stack>
            </Grid>
        </Fragment>
    );

    useEffect(() => {
        if (
            typeof props.dockAt !== "undefined" &&
            typeof props.show !== "undefined"
        ) {
            if (props.show) {
                setState({ ...state, [props.dockAt]: props.show });
            }
        }
        //eslint-disable-next-line
    }, [props.show]);
    useEffect(() => {
        if (props.orgStructure.organizationalStructure) {
            setOrganizationalStructure(props.orgStructure.organizationalStructure)
        }
    }, [props.orgStructure])
    return (
        <div>
            {typeof props.dockAt !== "undefined" && (
                <React.Fragment>
                    <Drawer
                        anchor={props.dockAt}
                        open={state[props.dockAt]}
                        onClose={() => {
                            collapseAll();
                            setState({
                                ...state,
                                [props.dockAt!]: false
                            });
                            props.handleClose();
                        }}
                        sx={{ zIndex: "11" }}
                    >
                        {list(props.dockAt)}
                    </Drawer>
                </React.Fragment>
            )}
        </div>
    )
}